// src/IT/components/StatusPill.jsx
import React from "react";

export default function StatusPill({ status }) {
  const s = String(status || "").toLowerCase();
  return <span className={`it-pill it-${s}`}>{status}</span>;
}
